const copa = [
  {
    id: 0,
    selecao: "africa-do-sul",
    nome: "África do Sul - Uniforme 1",
    aliases: ["africa", "seleção", "seleção africana", "Africa do sul"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/afr-01/uni0.jpg",
      "/images/wc26/afr-01/uni1.jpg",
      "/images/wc26/afr-01/uni2.jpg",
      "/images/wc26/afr-01/uni3.jpg",
      "/images/wc26/afr-01/uni4.jpg",
    ],
  },
  {
    id: 1,
    selecao: "africa-do-sul",
    nome: "África do Sul - Uniforme 2",
    aliases: ["africa", "seleção", "seleção africana", "Africa do sul"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/afr-02/uni0.jpg",
      "/images/wc26/afr-02/uni1.jpg",
      "/images/wc26/afr-02/uni2.jpg",
      "/images/wc26/afr-02/uni3.jpg",
      "/images/wc26/afr-02/uni4.jpg",
    ],
  },
  {
    id: 2,
    selecao: "alemanha",
    nome: "Alemanha - Uniforme 1",
    aliases: ["alemanha", "seleção", "seleção alema"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/ale-01/uni0.jpg",
      "/images/wc26/ale-01/uni1.jpg",
      "/images/wc26/ale-01/uni2.jpg",
      "/images/wc26/ale-01/uni3.jpg",
      "/images/wc26/ale-01/uni4.jpg",
    ],
  },
  {
    id: 3,
    selecao: "alemanha",
    nome: "Alemanha - Uniforme 2",
    aliases: ["alemanha", "seleção", "seleção alema"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/ale-02/uni0.jpg",
      "/images/wc26/ale-02/uni1.jpg",
      "/images/wc26/ale-02/uni2.jpg",
      "/images/wc26/ale-02/uni3.jpg",
      "/images/wc26/ale-02/uni4.jpg",
    ],
  },
  {
    id: 4,
    selecao: "alemanha",
    nome: "Alemanha - Uniforme 3",
    aliases: ["alemanha", "seleção", "seleção alema"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/ale-03/uni0.jpg",
      "/images/wc26/ale-03/uni1.jpg",
      "/images/wc26/ale-03/uni2.jpg",
      "/images/wc26/ale-03/uni3.jpg",
      "/images/wc26/ale-03/uni4.jpg",
    ],
  },
  {
    id: 5,
    selecao: "arabia-saudita",
    nome: "Arábia Saudita - Uniforme 1",
    aliases: ["arabia", "seleção", "arabia saudita", "saudita"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/ara-01/uni0.jpg",
      "/images/wc26/ara-01/uni1.jpg",
      "/images/wc26/ara-01/uni2.jpg",
      "/images/wc26/ara-01/uni3.jpg",
      "/images/wc26/ara-01/uni4.jpg",
    ],
  },
  {
    id: 6,
    selecao: "argentina",
    nome: "Argentina - Uniforme 1",
    aliases: ["argentina", "seleção", "seleção argentina"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/arg-01/uni0.jpg",
      "/images/wc26/arg-01/uni1.jpg",
      "/images/wc26/arg-01/uni2.jpg",
      "/images/wc26/arg-01/uni3.jpg",
      "/images/wc26/arg-01/uni4.jpg",
    ],
  },
  {
    id: 7,
    selecao: "argentina",
    nome: "Argentina - Uniforme 2",
    aliases: ["argentina", "seleção", "seleção argentina"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/arg-02/uni0.jpg",
      "/images/wc26/arg-02/uni1.jpg",
      "/images/wc26/arg-02/uni2.jpg",
      "/images/wc26/arg-02/uni3.jpg",
      "/images/wc26/arg-02/uni4.jpg",
    ],
  },
  {
    id: 8,
    selecao: "argelia",
    nome: "Argélia - Uniforme 1",
    aliases: ["argelia", "seleção", "seleção argeliana"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/arge-01/uni0.jpg",
      "/images/wc26/arge-01/uni1.jpg",
      "/images/wc26/arge-01/uni2.jpg",
      "/images/wc26/arge-01/uni3.jpg",
      "/images/wc26/arge-01/uni4.jpg",
    ],
  },
  {
    id: 9,
    selecao: "argelia",
    nome: "Argélia - Uniforme 2",
    aliases: ["argelia", "seleção", "seleção argeliana"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/arge-02/uni0.jpg",
      "/images/wc26/arge-02/uni1.jpg",
      "/images/wc26/arge-02/uni2.jpg",
      "/images/wc26/arge-02/uni3.jpg",
      "/images/wc26/arge-02/uni4.jpg",
    ],
  },
  {
    id: 10,
    selecao: "argelia",
    nome: "Argélia - Uniforme 3",
    aliases: ["argelia", "seleção", "seleção argeliana"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/arge-03/uni0.jpg",
      "/images/wc26/arge-03/uni1.jpg",
      "/images/wc26/arge-03/uni2.jpg",
      "/images/wc26/arge-03/uni3.jpg",
      "/images/wc26/arge-03/uni4.jpg",
    ],
  },
  {
    id: 11,
    selecao: "australia",
    nome: "Austrália - Uniforme 3",
    aliases: ["australia", "seleção", "seleção australiana"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/aus-01/uni0.jpg",
      "/images/wc26/aus-01/uni1.jpg",
      "/images/wc26/aus-01/uni2.jpg",
      "/images/wc26/aus-01/uni3.jpg",
      "/images/wc26/aus-01/uni4.jpg",
    ],
  },
  {
    id: 12,
    selecao: "belgica",
    nome: "Bélgica - Uniforme 1",
    aliases: ["belgica", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/bel-01/uni0.jpg",
      "/images/wc26/bel-01/uni1.jpg",
      "/images/wc26/bel-01/uni2.jpg",
      "/images/wc26/bel-01/uni3.jpg",
      "/images/wc26/bel-01/uni4.jpg",
    ],
  },
  {
    id: 13,
    selecao: "belgica",
    nome: "Bélgica - Uniforme 2",
    aliases: ["belgica", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/bel-02/uni0.jpg",
      "/images/wc26/bel-02/uni1.jpg",
      "/images/wc26/bel-02/uni2.jpg",
      "/images/wc26/bel-02/uni3.jpg",
      "/images/wc26/bel-02/uni4.jpg",
    ],
  },
  {
    id: 14,
    selecao: "brasil",
    nome: "Brasil - Uniforme 1",
    aliases: ["brasil", "seleção", "seleção brasileira"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/bra-01/uni0.jpg",
      "/images/wc26/bra-01/uni1.jpg",
      "/images/wc26/bra-01/uni2.jpg",
      "/images/wc26/bra-01/uni3.jpg",
      "/images/wc26/bra-01/uni4.jpg",
    ],
  },
  {
    id: 15,
    selecao: "brasil",
    nome: "Brasil - Uniforme 2",
    aliases: ["brasil", "seleção", "seleção brasileira"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/bra-02/uni0.jpg",
      "/images/wc26/bra-02/uni1.jpg",
      "/images/wc26/bra-02/uni2.jpg",
      "/images/wc26/bra-02/uni3.jpg",
      "/images/wc26/bra-02/uni4.jpg",
    ],
  },
  {
    id: 16,
    selecao: "canada",
    nome: "Canadá - Uniforme 1",
    aliases: ["canada", "seleção", "seleção canadense"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/can-01/uni0.jpg",
      "/images/wc26/can-01/uni1.jpg",
      "/images/wc26/can-01/uni2.jpg",
      "/images/wc26/can-01/uni3.jpg",
      "/images/wc26/can-01/uni4.jpg",
    ],
  },
  {
    id: 17,
    selecao: "chile",
    nome: "Chile - Uniforme 1",
    aliases: ["chile", "seleção", "seleção chilena"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/chi-01/uni0.jpg",
      "/images/wc26/chi-01/uni1.jpg",
      "/images/wc26/chi-01/uni2.jpg",
      "/images/wc26/chi-01/uni3.jpg",
      "/images/wc26/chi-01/uni4.jpg",
    ],
  },
  {
    id: 18,
    selecao: "colombia",
    nome: "Colômbia - Uniforme 1",
    aliases: ["colombia", "seleção", "seleção colombiana"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/col-01/uni0.jpg",
      "/images/wc26/col-01/uni1.jpg",
      "/images/wc26/col-01/uni2.jpg",
      "/images/wc26/col-01/uni3.jpg",
      "/images/wc26/col-01/uni4.jpg",
    ],
  },
  {
    id: 19,
    selecao: "colombia",
    nome: "Colômbia - Uniforme 2",
    aliases: ["colombia", "seleção", "seleção colombiana"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/col-02/uni0.jpg",
      "/images/wc26/col-02/uni1.jpg",
      "/images/wc26/col-02/uni2.jpg",
      "/images/wc26/col-02/uni3.jpg",
      "/images/wc26/col-02/uni4.jpg",
    ],
  },
  {
    id: 20,
    selecao: "croacia",
    nome: "Croácia - Uniforme 1",
    aliases: ["croacia", "seleção", "seleção croata"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/cro-01/uni0.jpg",
      "/images/wc26/cro-01/uni1.jpg",
      "/images/wc26/cro-01/uni2.jpg",
      "/images/wc26/cro-01/uni3.jpg",
      "/images/wc26/cro-01/uni4.jpg",
    ],
  },
  {
    id: 21,
    selecao: "croacia",
    nome: "Croácia - Uniforme 2",
    aliases: ["croacia", "seleção", "seleção croata"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/cro-02/uni0.jpg",
      "/images/wc26/cro-02/uni1.jpg",
      "/images/wc26/cro-02/uni2.jpg",
      "/images/wc26/cro-02/uni3.jpg",
      "/images/wc26/cro-02/uni4.jpg",
    ],
  },
  {
    id: 22,
    selecao: "curacao",
    nome: "Curaçao - Uniforme 1",
    aliases: ["curacao", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/cur-01/uni0.jpg",
      "/images/wc26/cur-01/uni1.jpg",
      "/images/wc26/cur-01/uni2.jpg",
      "/images/wc26/cur-01/uni3.jpg",
      "/images/wc26/cur-01/uni4.jpg",
    ],
  },
  {
    id: 23,
    selecao: "curacao",
    nome: "Curaçao - Uniforme 2",
    aliases: ["curacao", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/cur-02/uni0.jpg",
      "/images/wc26/cur-02/uni1.jpg",
      "/images/wc26/cur-02/uni2.jpg",
      "/images/wc26/cur-02/uni3.jpg",
      "/images/wc26/cur-02/uni4.jpg",
    ],
  },
  {
    id: 24,
    selecao: "eau",
    nome: "Emirados Árabes Unidos - Uniforme 1",
    aliases: ["eau", "seleção", "emirados arabes unidos"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/eau-01/uni0.jpg",
      "/images/wc26/eau-01/uni1.jpg",
      "/images/wc26/eau-01/uni2.jpg",
      "/images/wc26/eau-01/uni3.jpg",
      "/images/wc26/eau-01/uni4.jpg",
    ],
  },
  {
    id: 25,
    selecao: "equador",
    nome: "Equador - Uniforme 1",
    aliases: ["equador", "seleção", "seleção equatoriana"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/ecu-01/uni0.jpg",
      "/images/wc26/ecu-01/uni1.jpg",
      "/images/wc26/ecu-01/uni2.jpg",
      "/images/wc26/ecu-01/uni3.jpg",
      "/images/wc26/ecu-01/uni4.jpg",
    ],
  },
  {
    id: 26,
    selecao: "equador",
    nome: "Equador - Uniforme 2",
    aliases: ["equador", "seleção", "seleção equatoriana"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/ecu-02/uni0.jpg",
      "/images/wc26/ecu-02/uni1.jpg",
      "/images/wc26/ecu-02/uni2.jpg",
      "/images/wc26/ecu-02/uni3.jpg",
      "/images/wc26/ecu-02/uni4.jpg",
    ],
  },
  {
    id: 27,
    selecao: "equador",
    nome: "Equador - Uniforme 3",
    aliases: ["equador", "seleção", "seleção equatoriana"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/ecu-03/uni0.jpg",
      "/images/wc26/ecu-03/uni1.jpg",
      "/images/wc26/ecu-03/uni2.jpg",
      "/images/wc26/ecu-03/uni3.jpg",
      "/images/wc26/ecu-03/uni4.jpg",
    ],
  },
  {
    id: 28,
    selecao: "egito",
    nome: "Egito - Uniforme 2",
    aliases: ["egito", "seleção", "seleção egipcia"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/egi-02/uni0.jpg",
      "/images/wc26/egi-02/uni1.jpg",
      "/images/wc26/egi-02/uni2.jpg",
      "/images/wc26/egi-02/uni3.jpg",
      "/images/wc26/egi-02/uni4.jpg",
    ],
  },
  {
    id: 29,
    selecao: "escocia",
    nome: "Escócia - Uniforme 1",
    aliases: ["escocia", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/esc-01/uni0.jpg",
      "/images/wc26/esc-01/uni1.jpg",
      "/images/wc26/esc-01/uni2.jpg",
      "/images/wc26/esc-01/uni3.jpg",
      "/images/wc26/esc-01/uni4.jpg",
    ],
  },
  {
    id: 30,
    selecao: "escocia",
    nome: "Escócia - Uniforme 2",
    aliases: ["escocia", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/esc-02/uni0.jpg",
      "/images/wc26/esc-02/uni1.jpg",
      "/images/wc26/esc-02/uni2.jpg",
      "/images/wc26/esc-02/uni3.jpg",
      "/images/wc26/esc-02/uni4.jpg",
    ],
  },
  {
    id: 31,
    selecao: "espanha",
    nome: "Espanha - Uniforme 1",
    aliases: ["espanha", "seleção", "seleção espanhola"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/esp-01/uni0.jpg",
      "/images/wc26/esp-01/uni1.jpg",
      "/images/wc26/esp-01/uni2.jpg",
      "/images/wc26/esp-01/uni3.jpg",
      "/images/wc26/esp-01/uni4.jpg",
    ],
  },
  {
    id: 32,
    selecao: "espanha",
    nome: "Espanha - Uniforme 2",
    aliases: ["espanha", "seleção", "seleção espanhola"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/esp-02/uni0.jpg",
      "/images/wc26/esp-02/uni1.jpg",
      "/images/wc26/esp-02/uni2.jpg",
      "/images/wc26/esp-02/uni3.jpg",
      "/images/wc26/esp-02/uni4.jpg",
    ],
  },
  {
    id: 33,
    selecao: "eua",
    nome: "Estados Unidos - Uniforme 1",
    aliases: ["eua", "seleção", "estados unidos"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/eua-01/uni0.jpg",
      "/images/wc26/eua-01/uni1.jpg",
      "/images/wc26/eua-01/uni2.jpg",
      "/images/wc26/eua-01/uni3.jpg",
      "/images/wc26/eua-01/uni4.jpg",
    ],
  },
  {
    id: 34,
    selecao: "eua",
    nome: "Estados Unidos - Uniforme 2",
    aliases: ["eua", "seleção", "estados unidos"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/usa-02/uni0.jpg",
      "/images/wc26/usa-02/uni1.jpg",
      "/images/wc26/usa-02/uni2.jpg",
      "/images/wc26/usa-02/uni3.jpg",
      "/images/wc26/usa-02/uni4.jpg",
    ],
  },
  {
    id: 35,
    selecao: "franca",
    nome: "França - Uniforme 1",
    aliases: ["franca", "seleção", "estados francesa"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/fra-01/uni0.jpg",
      "/images/wc26/fra-01/uni1.jpg",
      "/images/wc26/fra-01/uni2.jpg",
      "/images/wc26/fra-01/uni3.jpg",
      "/images/wc26/fra-01/uni4.jpg",
    ],
  },
  {
    id: 36,
    selecao: "franca",
    nome: "França - Uniforme 2",
    aliases: ["franca", "seleção", "estados francesa"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/fra-02/uni0.jpg",
      "/images/wc26/fra-02/uni1.jpg",
      "/images/wc26/fra-02/uni2.jpg",
      "/images/wc26/fra-02/uni3.jpg",
      "/images/wc26/fra-02/uni4.jpg",
    ],
  },
  {
    id: 37,
    selecao: "gana",
    nome: "Gana - Uniforme 1",
    aliases: ["gana", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/gha-01/uni0.jpg",
      "/images/wc26/gha-01/uni1.jpg",
      "/images/wc26/gha-01/uni2.jpg",
      "/images/wc26/gha-01/uni3.jpg",
      "/images/wc26/gha-01/uni4.jpg",
    ],
  },
  {
    id: 38,
    selecao: "haiti",
    nome: "Haiti - Uniforme 1",
    aliases: ["haiti", "seleção", "seleção haitiana"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/hai-01/uni0.jpg",
      "/images/wc26/hai-01/uni1.jpg",
      "/images/wc26/hai-01/uni2.jpg",
      "/images/wc26/hai-01/uni3.jpg",
      "/images/wc26/hai-01/uni4.jpg",
    ],
  },
  {
    id: 39,
    selecao: "haiti",
    nome: "Haiti - Uniforme 2",
    aliases: ["haiti", "seleção", "seleção haitiana"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/hai-02/uni0.jpg",
      "/images/wc26/hai-02/uni1.jpg",
      "/images/wc26/hai-02/uni2.jpg",
      "/images/wc26/hai-02/uni3.jpg",
      "/images/wc26/hai-02/uni4.jpg",
    ],
  },
  {
    id: 40,
    selecao: "haiti",
    nome: "Haiti - Uniforme 3",
    aliases: ["haiti", "seleção", "seleção haitiana"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/hai-03/uni0.jpg",
      "/images/wc26/hai-03/uni1.jpg",
      "/images/wc26/hai-03/uni2.jpg",
      "/images/wc26/hai-03/uni3.jpg",
      "/images/wc26/hai-03/uni4.jpg",
    ],
  },
  {
    id: 41,
    selecao: "holanda",
    nome: "Holanda - Uniforme 1",
    aliases: ["holanda", "seleção", "seleção holandesa"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/hol-01/uni0.jpg",
      "/images/wc26/hol-01/uni1.jpg",
      "/images/wc26/hol-01/uni2.jpg",
      "/images/wc26/hol-01/uni3.jpg",
      "/images/wc26/hol-01/uni4.jpg",
    ],
  },
  {
    id: 42,
    selecao: "holanda",
    nome: "Holanda - Uniforme 2",
    aliases: ["holanda", "seleção", "seleção holandesa"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/hol-02/uni0.jpg",
      "/images/wc26/hol-02/uni1.jpg",
      "/images/wc26/hol-02/uni2.jpg",
      "/images/wc26/hol-02/uni3.jpg",
      "/images/wc26/hol-02/uni4.jpg",
    ],
  },
  {
    id: 43,
    selecao: "hungria",
    nome: "Hungria - Uniforme 1",
    aliases: ["hungria", "seleção", "seleção hungara"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/hun-01/uni0.jpg",
      "/images/wc26/hun-01/uni1.jpg",
      "/images/wc26/hun-01/uni2.jpg",
      "/images/wc26/hun-01/uni3.jpg",
      "/images/wc26/hun-01/uni4.jpg",
    ],
  },
  {
    id: 44,
    selecao: "inglaterra",
    nome: "Inglaterra - Uniforme 2",
    aliases: ["inglaterra", "seleção", "seleção inglesa"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/ing-01/uni0.jpg",
      "/images/wc26/ing-01/uni1.jpg",
      "/images/wc26/ing-01/uni2.jpg",
      "/images/wc26/ing-01/uni3.jpg",
      "/images/wc26/ing-01/uni4.jpg",
    ],
  },
  {
    id: 45,
    selecao: "jordania",
    nome: "Jordânia - Uniforme 1",
    aliases: ["jordania", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/jor-01/uni0.jpg",
      "/images/wc26/jor-01/uni1.jpg",
      "/images/wc26/jor-01/uni2.jpg",
      "/images/wc26/jor-01/uni3.jpg",
      "/images/wc26/jor-01/uni4.jpg",
    ],
  },
  {
    id: 46,
    selecao: "jordania",
    nome: "Jordânia - Uniforme 2",
    aliases: ["jordania", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/jor-02/uni0.jpg",
      "/images/wc26/jor-02/uni1.jpg",
      "/images/wc26/jor-02/uni2.jpg",
      "/images/wc26/jor-02/uni3.jpg",
      "/images/wc26/jor-02/uni4.jpg",
    ],
  },
  {
    id: 47,
    selecao: "jordania",
    nome: "Jordânia - Uniforme 3",
    aliases: ["jordania", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/jor-03/uni0.jpg",
      "/images/wc26/jor-03/uni1.jpg",
      "/images/wc26/jor-03/uni2.jpg",
      "/images/wc26/jor-03/uni3.jpg",
      "/images/wc26/jor-03/uni4.jpg",
    ],
  },
  {
    id: 48,
    selecao: "marrocos",
    nome: "Marrocos - Uniforme 1",
    aliases: ["marrocos", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/mar-01/uni0.jpg",
      "/images/wc26/mar-01/uni1.jpg",
      "/images/wc26/mar-01/uni2.jpg",
      "/images/wc26/mar-01/uni3.jpg",
      "/images/wc26/mar-01/uni4.jpg",
    ],
  },
  {
    id: 49,
    selecao: "marrocos",
    nome: "Marrocos - Uniforme 2",
    aliases: ["marrocos", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/mar-02/uni0.jpg",
      "/images/wc26/mar-02/uni1.jpg",
      "/images/wc26/mar-02/uni2.jpg",
      "/images/wc26/mar-02/uni3.jpg",
      "/images/wc26/mar-02/uni4.jpg",
    ],
  },
  {
    id: 50,
    selecao: "mexico",
    nome: "México - Uniforme 1",
    aliases: ["mexico", "seleção", "seleção mexicana"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/mex-01/uni0.jpg",
      "/images/wc26/mex-01/uni1.jpg",
      "/images/wc26/mex-01/uni2.jpg",
      "/images/wc26/mex-01/uni3.jpg",
      "/images/wc26/mex-01/uni4.jpg",
    ],
  },
  {
    id: 51,
    selecao: "mexico",
    nome: "México - Uniforme 2",
    aliases: ["mexico", "seleção", "seleção mexicana"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/mex-02/uni0.jpg",
      "/images/wc26/mex-02/uni1.jpg",
      "/images/wc26/mex-02/uni2.jpg",
      "/images/wc26/mex-02/uni3.jpg",
      "/images/wc26/mex-02/uni4.jpg",
    ],
  },
  {
    id: 52,
    selecao: "noruega",
    nome: "Noruega - Uniforme 1",
    aliases: ["noruega", "seleção", "seleção norueguesa"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/nor-01/uni0.jpg",
      "/images/wc26/nor-01/uni1.jpg",
      "/images/wc26/nor-01/uni2.jpg",
      "/images/wc26/nor-01/uni3.jpg",
      "/images/wc26/nor-01/uni4.jpg",
    ],
  },
  {
    id: 53,
    selecao: "noruega",
    nome: "Noruega - Uniforme 2",
    aliases: ["noruega", "seleção", "seleção norueguesa"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/nor-02/uni0.jpg",
      "/images/wc26/nor-02/uni1.jpg",
      "/images/wc26/nor-02/uni2.jpg",
      "/images/wc26/nor-02/uni3.jpg",
      "/images/wc26/nor-02/uni4.jpg",
    ],
  },
  {
    id: 54,
    selecao: "nova-zelandia",
    nome: "Nova Zelândia - Uniforme 1",
    aliases: ["nova zelandia", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/nov-01/uni0.jpg",
      "/images/wc26/nov-01/uni1.jpg",
      "/images/wc26/nov-01/uni2.jpg",
      "/images/wc26/nov-01/uni3.jpg",
      "/images/wc26/nov-01/uni4.jpg",
    ],
  },
  {
    id: 55,
    selecao: "pais-de-gales",
    nome: "País de Gales - Uniforme 1",
    aliases: ["pais de gales", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/pai-01/uni0.jpg",
      "/images/wc26/pai-01/uni1.jpg",
      "/images/wc26/pai-01/uni2.jpg",
      "/images/wc26/pai-01/uni3.jpg",
      "/images/wc26/pai-01/uni4.jpg",
    ],
  },
  {
    id: 56,
    selecao: "pais-de-gales",
    nome: "País de Gales - Uniforme 2",
    aliases: ["pais de gales", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/pai-02/uni0.jpg",
      "/images/wc26/pai-02/uni1.jpg",
      "/images/wc26/pai-02/uni2.jpg",
      "/images/wc26/pai-02/uni3.jpg",
      "/images/wc26/pai-02/uni4.jpg",
    ],
  },
  {
    id: 57,
    selecao: "paraguai",
    nome: "Paraguai - Uniforme 1",
    aliases: ["paraguai", "seleção", "seleção paraguaia"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/par-01/uni0.jpg",
      "/images/wc26/par-01/uni1.jpg",
      "/images/wc26/par-01/uni2.jpg",
      "/images/wc26/par-01/uni3.jpg",
      "/images/wc26/par-01/uni4.jpg",
    ],
  },
  {
    id: 58,
    selecao: "paraguai",
    nome: "Paraguai - Uniforme 2",
    aliases: ["paraguai", "seleção", "seleção paraguaia"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/par-02/uni0.jpg",
      "/images/wc26/par-02/uni1.jpg",
      "/images/wc26/par-02/uni2.jpg",
      "/images/wc26/par-02/uni3.jpg",
      "/images/wc26/par-02/uni4.jpg",
    ],
  },
  {
    id: 59,
    selecao: "portugal",
    nome: "Portugal - Uniforme 1",
    aliases: ["portugal", "seleção", "seleção portuguesa"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/por-01/uni0.jpg",
      "/images/wc26/por-01/uni1.jpg",
      "/images/wc26/por-01/uni2.jpg",
      "/images/wc26/por-01/uni3.jpg",
      "/images/wc26/por-01/uni4.jpg",
    ],
  },
  {
    id: 60,
    selecao: "portugal",
    nome: "Portugal - Uniforme 2",
    aliases: ["portugal", "seleção", "seleção portuguesa"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/por-02/uni0.jpg",
      "/images/wc26/por-02/uni1.jpg",
      "/images/wc26/por-02/uni2.jpg",
      "/images/wc26/por-02/uni3.jpg",
      "/images/wc26/por-02/uni4.jpg",
    ],
  },
  {
    id: 61,
    selecao: "portugal",
    nome: "Portugal - Uniforme 3",
    aliases: ["portugal", "seleção", "seleção portuguesa"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/por-03/uni0.jpg",
      "/images/wc26/por-03/uni1.jpg",
      "/images/wc26/por-03/uni2.jpg",
      "/images/wc26/por-03/uni3.jpg",
      "/images/wc26/por-03/uni4.jpg",
    ],
  },
  {
    id: 62,
    selecao: "qatar",
    nome: "Qatar - Uniforme 1",
    aliases: ["qatar", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/qat-01/uni0.jpg",
      "/images/wc26/qat-01/uni1.jpg",
      "/images/wc26/qat-01/uni2.jpg",
      "/images/wc26/qat-01/uni3.jpg",
      "/images/wc26/qat-01/uni4.jpg",
    ],
  },
  {
    id: 63,
    selecao: "republica-tcheca",
    nome: "Republica Tcheca - Uniforme 1",
    aliases: ["republica tcheca", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/rep-01/uni0.jpg",
      "/images/wc26/rep-01/uni1.jpg",
      "/images/wc26/rep-01/uni2.jpg",
      "/images/wc26/rep-01/uni3.jpg",
      "/images/wc26/rep-01/uni4.jpg",
    ],
  },
  {
    id: 64,
    selecao: "senegal",
    nome: "Senegal - Uniforme 1",
    aliases: ["senegal", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/sen-01/uni0.jpg",
      "/images/wc26/sen-01/uni1.jpg",
      "/images/wc26/sen-01/uni2.jpg",
      "/images/wc26/sen-01/uni3.jpg",
      "/images/wc26/sen-01/uni4.jpg",
    ],
  },
  {
    id: 65,
    selecao: "senegal",
    nome: "Senegal - Uniforme 2",
    aliases: ["senegal", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/sen-02/uni0.jpg",
      "/images/wc26/sen-02/uni1.jpg",
      "/images/wc26/sen-02/uni2.jpg",
      "/images/wc26/sen-02/uni3.jpg",
      "/images/wc26/sen-02/uni4.jpg",
    ],
  },
  {
    id: 66,
    selecao: "suecia",
    nome: "Suécia - Uniforme 1",
    aliases: ["suecia", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/sue-01/uni0.jpg",
      "/images/wc26/sue-01/uni1.jpg",
      "/images/wc26/sue-01/uni2.jpg",
      "/images/wc26/sue-01/uni3.jpg",
      "/images/wc26/sue-01/uni4.jpg",
    ],
  },
  {
    id: 67,
    selecao: "suecia",
    nome: "Suécia - Uniforme 2",
    aliases: ["suecia", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/sue-02/uni0.jpg",
      "/images/wc26/sue-02/uni1.jpg",
      "/images/wc26/sue-02/uni2.jpg",
      "/images/wc26/sue-02/uni3.jpg",
      "/images/wc26/sue-02/uni4.jpg",
    ],
  },
  {
    id: 68,
    selecao: "suica",
    nome: "Suiça - Uniforme 2",
    aliases: ["suiça", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/sui-02/uni0.jpg",
      "/images/wc26/sui-02/uni1.jpg",
      "/images/wc26/sui-02/uni2.jpg",
      "/images/wc26/sui-02/uni3.jpg",
      "/images/wc26/sui-02/uni4.jpg",
    ],
  },
  {
    id: 69,
    selecao: "tunisia",
    nome: "Tunísia - Uniforme 1",
    aliases: ["tunísia", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/tun-01/uni0.jpg",
      "/images/wc26/tun-01/uni1.jpg",
      "/images/wc26/tun-01/uni2.jpg",
      "/images/wc26/tun-01/uni3.jpg",
      "/images/wc26/tun-01/uni4.jpg",
    ],
  },
  {
    id: 70,
    selecao: "tunisia",
    nome: "Tunísia - Uniforme 2",
    aliases: ["tunísia", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/tun-02/uni0.jpg",
      "/images/wc26/tun-02/uni1.jpg",
      "/images/wc26/tun-02/uni2.jpg",
      "/images/wc26/tun-02/uni3.jpg",
      "/images/wc26/tun-02/uni4.jpg",
    ],
  },
  {
    id: 71,
    selecao: "tunisia",
    nome: "Tunísia - Uniforme 3",
    aliases: ["tunísia", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/tun-03/uni0.jpg",
      "/images/wc26/tun-03/uni1.jpg",
      "/images/wc26/tun-03/uni2.jpg",
      "/images/wc26/tun-03/uni3.jpg",
      "/images/wc26/tun-03/uni4.jpg",
    ],
  },
  {
    id: 72,
    selecao: "ucrania",
    nome: "Ucrânia - Uniforme 1",
    aliases: ["ucrania", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/ucr-01/uni0.jpg",
      "/images/wc26/ucr-01/uni1.jpg",
      "/images/wc26/ucr-01/uni2.jpg",
      "/images/wc26/ucr-01/uni3.jpg",
      "/images/wc26/ucr-01/uni4.jpg",
    ],
  },
  {
    id: 73,
    selecao: "uruguai",
    nome: "Uruguai - Uniforme 2",
    aliases: ["uruguai", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/uru-02/uni0.jpg",
      "/images/wc26/uru-02/uni1.jpg",
      "/images/wc26/uru-02/uni2.jpg",
      "/images/wc26/uru-02/uni3.jpg",
      "/images/wc26/uru-02/uni4.jpg",
    ],
  },
  {
    id: 74,
    selecao: "venezuela",
    nome: "Venezuela - Uniforme 1",
    aliases: ["venezuela", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/ven-01/uni0.jpg",
      "/images/wc26/ven-01/uni1.jpg",
      "/images/wc26/ven-01/uni2.jpg",
      "/images/wc26/ven-01/uni3.jpg",
      "/images/wc26/ven-01/uni4.jpg",
    ],
  },
  {
    id: 75,
    selecao: "venezuela",
    nome: "Venezuela - Uniforme 2",
    aliases: ["venezuela", "seleção"],
    tipo: "copa-do-mundo",
    imagens: [
      "/images/wc26/ven-02/uni0.jpg",
      "/images/wc26/ven-02/uni1.jpg",
      "/images/wc26/ven-02/uni2.jpg",
      "/images/wc26/ven-02/uni3.jpg",
      "/images/wc26/ven-02/uni4.jpg",
    ],
  },
];

export default copa;
